// extracted by mini-css-extract-plugin
export default {"homeWrapper":"Home_homeWrapper__2jyhT","navigation":"Home_navigation__hQ+D4","homeButton":"Home_homeButton__bIa+Q"};